import { useState, useEffect } from 'react';

/**
 * useAlert — Toast 消息管理
 * 从 EditorContent 提取的 alertMsg state + 自动清除 effect。
 * 减少 EditorContent 的 state 数量，同时保持 setAlertMsg 接口不变。
 *
 * @param {number} duration - 自动清除延时（毫秒），默认 2500
 * @returns {{ alertMsg, setAlertMsg }}
 */
export default function useAlert(duration = 2500) {
  const [alertMsg, setAlertMsg] = useState(null);

  useEffect(() => {
    if (alertMsg) {
      const timer = setTimeout(() => setAlertMsg(null), duration);
      return () => clearTimeout(timer);
    }
  }, [alertMsg, duration]);

  return { alertMsg, setAlertMsg };
}
